export default {
  "common_dialog_accept": "確定",
  "common_dialog_cancel": "取消",
  "common_alert_system_busy": "系統忙碌中, 請稍後再試",
  "common_button_commit": "送出",
  "common_button_confirm": "確認",
  "common_button_complete": "完成",
  "common_loading": "讀取中",
  "phone_input_country_code": "區域代碼",
  "phone_input_country_error": "選擇區域代碼",
  "phone_input_number_hint": "手機號碼",
  "phone_input_number_example": "範例",
  "title_invite_code": "輸入邀請碼",
  "title_active_account": "輸入啟動碼",
  "title_login": "登入",
  "title_system_name": "樓易健康坎點預測系統",
  "title_basic_info": "基本資料",
  "title_question": "健康問卷",
  "title_report": "會員報告",
  "title_contact": "連繫客服",
  "title_privacy_policy": "隱私權政策",
  "title_services": "服務條款",
  "title_edit_basic_info": "帳戶設置",
  "menu_account_setting": "帳戶設置",
  "menu_account_setting_basic_info": "基本資料",
  "menu_more": "更多檢測",
  "menu_more_skin_test": "膚質檢測",
  "menu_about_us": "關於我們",
  "menu_about_us_louyiai": "樓易健康科技官方網站",
  "menu_about_us_contact": "聯繫客服",
  "menu_about_us_privacy_policy": "隱私權政策",
  "menu_about_us_services": "服務條款",
  "menu_about_us_other": "其他",
  "menu_about_us_logout": "登出",
  "home_field_invite_code": "邀請碼",
  "home_field_invite_code_hint": "請輸入邀請碼",
  "home_field_invite_code_error": "邀請碼錯誤",
  "active_account_field_active_code": "啟動碼",
  "active_account_field_active_code_hint": "請輸入啟動碼",
  "active_account_field_invite_code_error": "啟動碼錯誤",
  "concat_mail": "樓易客服郵箱",
  "concat_time": "周一至周五(例假日除外)",
  "before_start_content": "樓中亮醫師團隊 以中醫理論及樓氏古中醫為核心，\n輔助以AI人工智慧和大資料庫等，\n使其數位化、生活化、定制化和普及化，\n讓大眾不只可以了解自身的身體狀況也可以實現「算病、防病、治病」，讓健康更加容易。",
  "before_start_button_start": "開始",
  "basic_info_field_unknow": "未知",
  "basic_info_hint": "提示",
  "basic_info_hint_content": "基本資料將會影響報告結果，請填寫正確，謝謝。",
  "basic_info_field_select": "請選擇",
  "basic_info_field_select_year": "年",
  "basic_info_field_select_month": "月",
  "basic_info_field_select_date": "日",
  "basic_info_field_select_tw": "民國 {0}",
  "basic_info_field_unknow": "未知",
  "basic_info_field_name": "姓名",
  "basic_info_field_name_hint": "樓小易",
  "basic_info_field_gender": "性別",
  "basic_info_field_gender_0": "女",
  "basic_info_field_gender_1": "男",
  "basic_info_field_blood_type": "血型",
  "basic_info_field_blood_type_A": "A型",
  "basic_info_field_blood_type_B": "B型",
  "basic_info_field_blood_type_O": "O型",
  "basic_info_field_blood_type_AB": "AB型",
  "basic_info_field_birth_date": "出生日期",
  "basic_info_field_birth_type_solor": "陽曆",
  "basic_info_field_birth_type_lunar": "陰曆(農曆)",
  "basic_info_field_birth_solor": "陽曆生日",
  "basic_info_field_birth_lunar": "陰曆生日",
  "basic_info_field_lunar_to_solor": "陰曆自動轉換陽曆",
  "basic_info_field_solor_to_lunar": "陽曆自動轉換陰曆",
  "basic_info_field_isleap_in_solar": "(閏)",
  "basic_info_field_isleap": "閏月",
  "basic_info_mobile": "手機號碼",
  "basic_info_field_birth_hour": "出生時辰",
  "basic_info_field_birth_hour_select_0": "早子",
  "basic_info_field_birth_hour_select_1": "丑",
  "basic_info_field_birth_hour_select_3": "寅",
  "basic_info_field_birth_hour_select_5": "卯",
  "basic_info_field_birth_hour_select_7": "辰",
  "basic_info_field_birth_hour_select_9": "巳",
  "basic_info_field_birth_hour_select_11": "午",
  "basic_info_field_birth_hour_select_13": "未",
  "basic_info_field_birth_hour_select_15": "申",
  "basic_info_field_birth_hour_select_17": "酉",
  "basic_info_field_birth_hour_select_19": "戌",
  "basic_info_field_birth_hour_select_21": "亥",
  "basic_info_field_birth_hour_select_23": "夜子",
  "basic_info_field_constitution": "體質",
  "basic_info_field_constitution_C101": "陽虛",
  "basic_info_field_constitution_C103": "陰虛",
  "basic_info_field_constitution_C104": "氣虛",
  "basic_info_field_constitution_C105": "濕熱",
  "basic_info_field_constitution_C106": "痰濕",
  "basic_info_field_constitution_C107": "氣鬱",
  "basic_info_field_constitution_C109": "血瘀",
  "basic_info_field_constitution_C110": "過敏",
  "basic_info_button_next": "下一步",
  "basic_info_field_auto_creat": "將自動產生",
  "basic_info_field_name_message": "請輸入姓名",
  "basic_info_field_gender_message": "請選擇性別",
  "basic_info_field_birth_date_message": "請選擇出生日期",
  "basic_info_field_birth_hour_message": "請選擇出生時辰",
  "basic_info_field_blood_type_message": "請選擇血型",
  "basic_info_field_lunar_message": "請先輸入陰曆生日",
  "basic_info_field_solor_message": "請先輸入陽曆生日",
  "edit_basic_info_field_name": "姓名",
  "edit_basic_info_field_name_hint": "樓小易",
  "edit_basic_info_field_mobile": "手機號碼",
  "edit_basic_info_field_token": "驗證碼",
  "edit_basic_info_field_token_hint": "請輸入手機驗證碼",
  "edit_basic_info_button_token_send": "發送驗證碼",
  "edit_basic_info_alert_modified_success": "修改成功",
  "edit_basic_info_field_mobile_verify_hint": "修改手機號碼請先驗證",
  "edit_basic_info_field_mobile_format_error": "手機格式錯誤",
  "verify_field_mobile_hint": "請輸入手機號碼",
  "verify_field_mobile_format_error": "手機格式錯誤",
  "verify_field_mobile_token_hint": "請輸入手機驗證碼",
  "verify_field_agree": "同意",
  "verify_field_privacy_policy": "隱私權政策",
  "verify_field_services": "服務條款",
  "verify_field_and": "及",
  "verify_button_token_send": "發送驗證碼",
  "verify_alert_agree": "如未同意服務條款及隱私權政策, 將無法繼續",
  "verify_alert_token_success": "驗證成功",
  "question_select_none": "沒有",
  "question_select_seldom": "很少",
  "question_select_sometimes": "有時",
  "question_select_often": "常常",
  "question_select_yes": "是",
  "question_select_no": "否",
  "question_hint_none": "近一個月內沒有發生",
  "question_hint_seldom": "近一個月內約3次(含)以下",
  "question_none_sometimes": "近一個月內約10次(含)以下",
  "question_none_often": "近一個月內超過10次",
  "question_button_prev": "上一頁",
  "question_button_next": "下一頁",
  "question_some_question_not_complete": "部分題目尚未完成",
  "result_subject_basic_info": "基本資料",
  "result_subject_unlucky_info": "坎點",
  "result_subject_constitution": "體質",
  "result_subject_constitution_common_status": "體質常見症狀",
  "result_subject_constitution_notice": "溫馨提醒",
  "result_subject_lucky_number": "心想事成密碼",
  "result_subject_lucky_direction": "開運方位",
  "result_subject_lucky_color": "幸運顏色",
  "result_subject_hid_sick": "潛在疾病",
  "result_subject_mix_constitution": "先後天體質綜合分析",
  "result_subject_congenital_constitution": "先天體質",
  "result_subject_most_sick": "最常發生疾病",
  "result_subject_second_sick": "較容易發生疾病",
  "result_subject_mix_sick": "先後天潛在疾病",
  "result_subject_bad_food": "忌吃食物",
  "result_subject_good_food": "宜吃食物",
  "result_subject_drink": "茶飲",
  "result_subject_recipe": "食療",
  "result_subject_acupoint": "穴道",
  "result_subject_exercise": "運動",
  "result_subject_extra_info": "磁場能量站",
  "result_subject_other": "其他",
  "result_subject_recommand": "精選推薦",
  "result_subject_recommand_product": "針對您的體質推薦以下產品",
  "result_unlucky_info_n_year_img": "{0}年坎點圖",
  "result_unlucky_info_what": "什麼是坎點？",
  "result_unlucky_info_description": "以易經而言，坎點就像是河中的深洞，踩入容易溺斃。\n若以人體的觀點來看，每個人在不同時間點的磁場都不一樣，有先天的因素也有後天的影響，就好比先天弱臟，特別容易受到內、外環境影響而產生磁場波動。\n樓易健康坎點系統透過五運六氣天氣醫學、個人先後天體質、大數據分析，進而推算出個人當下的磁場變化，當磁場較弱的時候，系統就會將其磁場圖畫入坎區並標註出坎點，表示這段時間可能會出現健康上的關卡。\n當我們知道坎點的時間區段後，就可以提前注意身體，及早保養調理，達到預防疾病的目的，以安然地度過這段時間。",
  "result_fetch_field": "資料獲取失敗",
  "result_fetch_retry": "重新嘗試",
  "result_share": "分享",
  "result_share_content": "您的朋友做了坎點預測, 一起來測驗吧",
  "result_retest": "再次測驗",
  "result_retest_time": "下次檢測時間 {0}年{1}月{2}日",
  "result_retest_hint": "您有一次重新測驗機會",
  "result_you_are_constitution": "您為{0}體質",
  "result_qi_1": "初之氣",
  "result_qi_2": "二之氣",
  "result_qi_3": "三之氣",
  "result_qi_4": "四之氣",
  "result_qi_5": "五之氣",
  "result_qi_6": "六之氣",
  "privacy_policy": "「{0}」是由「樓易健康科技股份有限公司」（下稱我們）所經營之網站(下稱本網站)各項服務與資訊。\n          以下是我們的隱私權保護政策，幫助您瞭解本網站所蒐集的個人資料之運用及保護方式。\n          一、隱私權保護政策的適用範圍\n          （1）請您在於使用本網站服務前，確認您已審閱並同意本隱私權政策所列全部條款，若您不同意全部或部份者，則請勿使用本網站服務。\n          （2）隱私權保護政策內容，包括我們如何處理您在使用本網站服務時蒐集到的個人識別資料。\n          （3）隱私權保護政策不適用於本網站以外的相關連結網站，亦不適用於非我們所委託或參與管理之人員。\n          二、個人資料的蒐集及使用\n          （1）於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進服務的參考依據，此記錄為內部應用，絕不對外公布。\n          （2）在使用我們的服務時，我們可能會要求您向我們提供可用於聯繫或識別您的某些個人資料，包括：\n          • C001辨識個人者： 如姓名、地址、電話、電子郵件等資訊。 •\n          C011個人描述：例如：性別、出生年月日等。\n          （3）本網站將蒐集的數據用於各種目的： •提供和維護系統所提供讀服務\n          •提供用戶支持 •提供分析或有價值訊息，以便我們改進服務\n          •監控服務的使用情況 •檢測，預防和解決技術問題\n          （4）本網站針對蒐集數據的利用期間、地區、對象及方式：\n          •期間：當事人要求停止使用或本服務停止提供服務之日為止。\n          •地區：個人資料將用於台灣地區。\n          •利用對象及方式：所蒐集到的資料將利用於各項業務之執行，利用方式為因業務執行所必須進行之各項分析、聯繫及通知。\n          三、資料的保護與安全\n          （1）本網站主機均設有防火牆、防毒系統等相關資訊安全設備及必要的安全防護措施，本網站及您的個人資料均受到嚴格的保護。只有經過授權的人員才能接觸您的個人資料，相關處理人員均有簽署保密合約，如有違反保密義務者，將會受到相關的法律處分。\n          （2）如因業務需要有必要委託本網站相關單位提供服務時，我們會要求其遵守保密義務，並採取相當之檢查程序以確定其將確實遵守。\n          （3）請您妥善保管您的密碼與個人資料，並提醒您使用完畢本網站相關服務後，務必關閉本網站，以免您的資料遭人盜用。\n          （4）您同意在使用本網站服務時，所留存的資料與事實相符。另若嗣後您發現您的個人資料遭他人非法使用或有任何異常時，應即時通知我們。\n          （5）您同意於使用本網站服務時，所提供及使用之資料皆為合法，並無侵害第三人權利、違反第三方協議或涉及任何違法行為。如因使用本APP服務而致第三人損害，除因我們故意或重大過失所致外，我們並不負擔相關賠償責任。\n          四、對外的相關連結\n          本網站上有可能包含其他合作網站或網頁連結，該網站或網頁也有可能會蒐集您的個人資料，不論其內容或隱私權政策為何，皆與本網站\n          無關，您應自行參考該連結網站中的隱私權保護政策，我們不負任何連帶責任。\n          五、與第三人共用個人資料之政策\n          （1）本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。\n          （2）前項但書之情形包括但不限於： •經由您書面同意。 •法律明文規定。\n          •為維護國家安全或增進公共利益。\n          •為免除您生命、身體、自由或財產上之危險。\n          •與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。\n          •當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。\n          •有利於您的權益。\n          （3）本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。\n          六、Cookie之使用\n          （1）為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的Cookie，若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能會導致網站某些功能無法正常執行\n          。 以下是可能使用的Cookie範例: •session cookies.\n          用來維護應用程式的狀態 •Preference Cookies. 用來記錄您的喜好與設定\n          •Security Cookies. 用來控制安全和檢查 七、未成年人保護\n          未成年人於註冊或使用本服務而同意本公司蒐集、利用其個人資訊時，應按其年齡由其法定代理人代為或在法定代理人之同意下為之。\n          八、隱私權政策的修訂\n          我們將因應需求擁有隨時修改本隱私權保護政策的權利，當我們做出修改時，會於本網站公告，且自公告日起生效，不再另行通知。",
  "services": "          一、會員服務及權利義務\n          1.歡迎您來到「{0}」（以下稱「本網站」），本網站由樓易健康科技股份有限公司(以下簡稱『樓易』)負責經營。\n          2.本網站主要提供您以下服務： ．商品銷售及配送服務 ．活動資訊提供\n          ．會員相關權益通知 本網站得依實際情形，增加、修改或是終止相關服務。\n          3.加入為樓易網路會員，您還可享有： ．紅利點數積點\n          ．紅利點數折抵優惠．不定期獲得樓易最新資訊、商品快報及好康活動。\n          4.若您開始使用本網站所提供之客戶服務時，即視為已知悉並完全同意本使用條款的所有約定並完全接受本服務的項目，您應自行\n          注意條款變動，本條款之內容如有異動將於本網站公告。如果您不同意修改的內容，應停止繼續使用本網站之服務。如果您繼續\n          使用本網站服務，則視為您已同意並接受本條款等增訂或修改內容之拘束。\n          5.若您未滿二十歲，應於您的法定代理人閱讀、瞭解並同意本約定書之所有內容及其後修改變更後，方得使用或繼續使用。當您使\n          用或繼續使用本網站，即表示您的法定代理人已閱讀、瞭解並同意接受本約定書之所有內容及其後修改變更。\n          6.本公司保有更改各項服務內容或終止任一違反法律規定或雙方約定之客戶帳戶服務之權利。此外本公司亦有權於任何時間基於需\n          要修改或變更本條款內容，並將修改內容於本網站公告。\n          二、客戶帳號、密碼與安全\n          1.您註冊網路會員時必須填寫確實資料，若發現有不實之登錄，或原所登錄資料已不符合真實而未更新，樓易保留隨時暫停或終\n          止您網路會員資格及使用各項服務資格之權利。若您冒用他人名義，並造成其他會員或本站之損失，樓易將保留追訴權，並提\n          供相關資料給警調單位調查。\n          2.為維護您的權益，請妥善保管您的網路會員帳號（以下簡稱帳號）及密碼，且每次連線完畢，均結束您的帳號使用,\n          同時，您應嚴防個人資料、付款資料（包含信用卡資料）及密碼外洩。您的帳號、密碼如有遺失或被竊之慮或有其他任何安全問題發生時，\n          應即時通知樓易網路商店並作修改，以免損害您本身權益，以同一個帳號和密碼進入後所進行的所有行為，都將被認為是該會\n          員本人的行為，若因您自行洩露帳號及密碼所造成之損害及法律責任，樓易網路商店不負連帶責任，利用該帳號及密碼所進行\n          的一切行動，您將負完全的責任。 三、智慧財產權\n          本網站所使用之軟體或程式及網站上所有內容除事先經樓易或其權利人之合法授權，任何人不得擅自使用、修改、重製、公開播\n          送等。如有違反，您應對本公司負損害賠償責任。 四、網路會員隱私權保障\n          1.您同意樓易蒐集、處理及利用個人資料於樓易業務之特定目的如下：行銷業務、客戶管理與服務、網路購物業務。\n          2.本公司對於網路會員所登錄或留存之個人資料，除樓易蒐集、處理及利用個人資料之特定目的外，除下列情形，絕不揭露網路\n          會員之姓名、地址、信用卡卡號、電子郵件地址及其他依法受保護之個人資料。\n          ※ 依法令規定、或依司法機關或其他有權機關的命令。\n          ※為執行本約定條款、或使用者違反約定條款。\n          ※為維護樓易網路商店系統之正常運作及安全。 ※ 經當事人書面同意。\n          3.您同意接受樓易之「隱私權保障」，樓易將盡力以合理之技術及程序，保障所有個人資料之安全。\n          五、暫停服務\n          1.本公司以目前一般認為合理之方式及技術，維護本服務之正常運作。但在下列情況之下，本公司將暫停或中斷本服務之全部或一\n          部分，因之對使用者所致任何直接或間接之影響，不負任何賠償或補償責任：\n          1-1.對本服務相關軟體設備進行搬遷、更換、升級、保養或維修。\n          1-2.使用者有任何違反政府法令或本使用條款情形。\n          1-3.天災或其他不可抗力之因素所導致之服務中斷或停止。\n          1-4.其他不可歸責於本公司之事由所致之服務中斷或停止。\n          1-5.非本公司所能控制之事由而致本服務資訊顯示不正確、或遭偽造、竄改、刪除或擷取、或致系統中斷或不能正常運作時。\n          2.本公司針對可預知之軟硬體維護工作，有可能導致系統中斷或是暫停者，將會於該狀況發生之前，以適當方式告知網路會員。\n          六、本條款之效力 . 本條款所定一部分無效時，不影響其他部份之效力。",
}